export const projectFour = {
  id: 'Project',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Project 4',
  headline: 'Scout',
  description:
    "An AI-driven tool designed to help dealers find cars faster with real-time insights on bid prices, time remaining, market value, and profit margins. Built a centralized, interactive live auction platform that streamlines vehicle sale insights, increasing overall purchase volume by 24%.",
  buttonLabel: 'Visit site',
  siteUrl: 'https://pacer.co/',
  imgStart: false,
  img: require('../../images/Scout.mp4'),
  alt: 'Scout',
  dark: true,
  primary: true,
  darkText: false
};
